module.exports = {
    "breadcrumbs": `Chemin de navigation`
};


//# sourceMappingURL=fr-FR.main.js.map
